
import { useState, useEffect } from 'react';

export default function Footer() {
  const [visitorCount, setVisitorCount] = useState(0);

  useEffect(() => {
    // 既存のカウントを取得（日付に関係なく継続）
    const storedCount = localStorage.getItem('visitorCount');
    const storedLastUpdate = localStorage.getItem('lastCountUpdate');
    const currentTime = Date.now();
    
    let initialCount = storedCount ? parseInt(storedCount) : 0;
    
    // 前回の更新から1時間経過していれば+3
    if (storedLastUpdate) {
      const lastUpdate = parseInt(storedLastUpdate);
      const timeDiff = currentTime - lastUpdate;
      const oneHour = 60 * 60 * 1000; // 1時間をミリ秒で
      
      if (timeDiff >= oneHour) {
        const incrementCount = Math.floor(timeDiff / oneHour) * 3;
        initialCount += incrementCount;
        localStorage.setItem('lastCountUpdate', currentTime.toString());
      }
    } else {
      localStorage.setItem('lastCountUpdate', currentTime.toString());
    }
    
    // 新規訪問者の場合は+1
    const hasVisited = sessionStorage.getItem('hasVisited');
    if (!hasVisited) {
      initialCount += 1;
      sessionStorage.setItem('hasVisited', 'true');
    }
    
    setVisitorCount(initialCount);
    localStorage.setItem('visitorCount', initialCount.toString());
    
    // 1時間ごとに+3するタイマー
    const interval = setInterval(() => {
      setVisitorCount(prev => {
        const newCount = prev + 3;
        localStorage.setItem('visitorCount', newCount.toString());
        localStorage.setItem('lastCountUpdate', Date.now().toString());
        return newCount;
      });
    }, 60 * 60 * 1000); // 1時間
    
    return () => clearInterval(interval);
  }, []);


  const quotes = [
    "止めない段取りを！",
    "交換の30分が、年間1,000万円を決める。",
    "再現性のない締付けが、品質と信用を削る。",
    "技能者が不在でも崩れない段取りの仕組みを！"
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 gap-8 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center mb-6">
              <img 
                src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/eb8ff83a3546fe57070bf812bafc35d3.jfif"
                alt="ZOLLER"
                className="h-12 w-auto"
              />
            </div>
            
            {/* 訪問者カウンター - ZOLLERロゴの下に配置 */}
            <div className="mb-6 bg-yellow-500 text-gray-900 px-6 py-3 rounded-xl shadow-lg inline-block">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-eye-line text-xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold">
                    {visitorCount.toLocaleString()}
                  </div>
                  <div className="text-sm font-medium">
                    累計訪問者数
                  </div>
                </div>
              </div>
            </div>
            
            <p className="text-gray-300 mb-6 leading-relaxed">
              インサート交換の自動化で、製造業の生産性向上と品質安定化を実現。
              年間1,000万円級の利益改善効果をお客様にお届けします。
            </p>
            <div className="space-y-2">
              {quotes.map((quote, index) => (
                <p key={index} className="text-yellow-400 text-sm italic">
                  「{quote}」
                </p>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">サービス</h3>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#solution" className="hover:text-yellow-400 transition-colors cursor-pointer">micBoxシステム</a></li>
              <li><a href="#roi" className="hover:text-yellow-400 transition-colors cursor-pointer">ROI計算</a></li>
              <li><a href="#" className="hover:text-yellow-400 transition-colors cursor-pointer">オンライン見学</a></li>
              <li><a href="#" className="hover:text-yellow-400 transition-colors cursor-pointer">90日パイロット</a></li>
              <li><a href="#" className="hover:text-yellow-400 transition-colors cursor-pointer">venturion/TMS連携</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">サポート</h3>
            <ul className="space-y-2 text-gray-300">
              <li>標準サポート：平日8:00–17:00</li>
              <li>（祝祭日除く）</li>
              <li className="pt-2">
                <strong className="text-white">ショールーム：</strong>
              </li>
              <li>大阪</li>
              <li>名古屋</li>
              <li>横浜</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-yellow-400 transition-colors cursor-pointer">会社情報</a>
              <a href="#" className="hover:text-yellow-400 transition-colors cursor-pointer">個人情報保護方針</a>
              <a href="#" className="hover:text-yellow-400 transition-colors cursor-pointer">利用規約</a>
              <a href="#" className="hover:text-yellow-400 transition-colors cursor-pointer">お問い合わせ</a>
            </div>
            
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-400">
                © ZOLLER Japan株式会社
              </span>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-yellow-400 transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
